import { render, staticRenderFns } from "./events-completed.vue?vue&type=template&id=230471fc&scoped=true&"
import script from "./events-completed.vue?vue&type=script&lang=js&"
export * from "./events-completed.vue?vue&type=script&lang=js&"
import style0 from "./events-completed.vue?vue&type=style&index=0&id=230471fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230471fc",
  null
  
)

/* custom blocks */
import block0 from "./events-completed.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports